module.exports = __webpack_public_path__ + "static/media/needs-6-outline.75ea0fea.png";